export const STARE_FIRMA_MAP = {
  0: { text: 'În așteptare', class: 'badge-warning' },
  1: { text: 'În verificare', class: 'badge-info' },
  2: { text: 'Activă', class: 'badge-success' },
  10: { text: 'Dezactivată', class: 'badge-light-danger' },
  11: { text: 'Blocat', class: 'badge-dark' }
};

export function getStareFirmaBadge(stare) {
  return STARE_FIRMA_MAP[stare] || { text: 'Necunoscută', class: 'badge-secondary' };
}